
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/rEditor/rootComps/helpHome/blocks/actionItem.scss.css.virtualfile';
        module.exports = {"helpHomeActionItem":"_helpHomeActionItem_1rfqo_7"};